import { IconButton, IconDrawOutline } from '@zillow/constellation';
import React from 'react';
import { toggleQuickComments } from 'store/order/quickForms/quickFormsSlice';
import { useAppDispatch } from 'store/store';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export const QuickComment = () => {
  const editPermissions = useHasPermissions([ePermissions.CommentsEdit]);
  const dispatch = useAppDispatch();
  return (
    <>
      {editPermissions && (
        <IconButton
          icon={<IconDrawOutline />}
          title={'Add Comment'}
          bare
          size={'sm'}
          onClick={() => dispatch(toggleQuickComments())}
        />
      )}
    </>
  );
};
